import React, { Component } from "react";
import ReadAxios from "../../axiosComponent/read";
import MiniPlaceholder from "./miniPlaceHolder";
import { Grid } from "semantic-ui-react";
import isEmpty from "lodash/isEmpty";

export class RouteManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routes: [],
    };
  }

  async componentDidMount() {
    console.log('route component called');
    let dataArray =
      (await ReadAxios({
        url: `routeManager/${this.props.routeId}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ routes: dataArray || [] });
  }

  async componentDidUpdate(prevProps) {
    console.log("vvvvvvvvvvVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVvvvvvvvvvv")
    console.log(prevProps)
    console.log(this.props)
    console.log(this.props.routeId != prevProps.routeId)
    if (this.props.routeId != prevProps.routeId) {
      let dataArray =
        (await ReadAxios({
          url: `routeManager/${this.props.routeId}`,
        })) || [];
      dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
      this.setState({ routes: dataArray || [] });
    }
    /* let dataArray =
      (await ReadAxios({
        url: `routeManager/${this.props.routeId}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ routes: dataArray || [] }); */
  }

  render() {
    const { routes } = this.state;
    return routes.length > 0 ? (
      <>
        <div style={{ marginBottom: "3em" }}>
          <Grid.Column width={1} style={{ position: "absolute", left: "0" }}>
            <img className='mt-2' src="assets/svg/navigation.svg" alt={""} width="20" />
            <p className='mt-3'>
              {this.props.budgeted_kms ? this.props.budgeted_kms : routes[0].budgetedKms} {" Kms"}
            </p>
          </Grid.Column>
          <div style={{ position: "absolute", left: "80px", marginTop: "15px" }}>
            <div className="w3-small ta-start" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <label title={`${routes[0].checkPointName}`}>
                {routes[0].checkPointName}
              </label>
            </div>
            <div
              className="w3-green timeline"
              style={{ marginLeft: "-2px", height: "50px", width: "3px" }}
            ></div>
            <div className="w3-small ta-end" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <label style={{ width: '100%' }} title={`${routes[routes.length - 1].checkPointName}`}>
                {routes[routes.length - 1].checkPointName}
              </label>
            </div>
          </div>
        </div>
      </>
    ) : (
      <MiniPlaceholder />
    );
  }
}

export default RouteManager;
